import { Subject } from 'rxjs';
import {Article} from '../blog-models/Article';
import firebase from 'firebase';

export class ArticleService {

    // Les images doivent être en 4:3
    // En 400:300 c'est sufisant tester 800:600 si beaucoup mieux
    public articles: Article[] = [];
    articlesSubject = new Subject<Article[]>();

    constructor() {
        this.getArticlesFromServer();
    }

    /**
     * emmetre la liste des articles
     * @returns 
     */
    emitArticles() {
        this.articlesSubject.next(this.articles.slice());
    }

    /**
     * Sauvegarder en BDD la liste actuelle des articles
     */
    saveArticlesOnServer() {
        // écraser les données à partir du noeud /articles
        firebase.database().ref('/articles').set(this.articles);
    }

    /**
     * Sauvegarder en BDD la liste actuelle des articles,
     * puis émettre les changements dans l'application
     */
    saveAndEmit() {
        this.saveArticlesOnServer();
        this.emitArticles();
    }

    /**
     * Mettre à jour la liste des articles local depuis la liste sur le serveur
     */
    getArticlesFromServer() {
        firebase.database().ref('/articles').on('value', 
            (data) => {     
                this.articles = data.val() ? data.val() : [];
                this.emitArticles();
            }
        );
    }

    /**
     * Récupérer depuis la BDD un article grâce à son Id
     * @param id 
     * @returns 
     */
    getArticleByIdFromServer(id: number): Promise<Article> {
        return new Promise(
            (resolve, reject) => {
                firebase.database().ref('/articles/' + id).once('value').then(
                    (data) => {
                        resolve(data.val() ? data.val() : null)
                    }, (error) => {
                        reject(error);
                    }
                );
            }
        );
    }

    getArticle(id: number) {
        return this.articles[id];
    }

    /**
     * Ajouter en local un nouvel article,
     * puis sauvegarder le changement en BDD
     * @param newArticle 
     */
    createNewArticle(newArticle: Article) {
        this.articles.push(newArticle);
        this.saveAndEmit();
    }

    /**
     * @todo
     * Supprimer un article grâce à son id
     * @param id 
     */
    removeArticleById(id: number) {
    }

    /**
     * Supprimer un article
     * @param articleToRemove 
     */
    removeArticle(articleToRemove: Article) {
        // Supprimer d'abord l'image de l'article
        this.removeImage(articleToRemove.pathImg);
        // Supprimer l'article entier
        const articleIndexToRemove = this.articles.findIndex(
          (articleEl) => {
            if(articleEl === articleToRemove) {
              return true;
            }
          }
        );
        this.articles.splice(articleIndexToRemove, 1);
        this.saveAndEmit();
    }

    /**
     * Supprimer une image grâce à son nom
     * @param imageName 
     */
    removeImage(imageName: string) {
        // Stocker la référence vers l'image à supprimer
        const storageRef = firebase.storage().refFromURL(imageName);
        // Supprimer l'image
        storageRef.delete().then(
            () => {
                console.log(imageName + 'supprimée');
            },
            (error) => {
                console.log("impossible de supprimer " + imageName);
                console.log(error);
            }
        );
    }

    getLastIndex() {
        return this.articles.length - 1;
    }

    uploadFile(file: File) {
        return new Promise(
            (resolve, reject) => {
                const timeId = Date.now().toString();
                const upload = firebase.storage().ref().child('images/' + timeId).put(file);
                upload.on(firebase.storage.TaskEvent.STATE_CHANGED, 
                    () => {
                        console.log('Chargement');
                    },
                    (error) => {
                        console.log('Erreur lors du chargement');
                        console.log(error);
                        reject();
                    },
                    () => {
                        resolve(upload.snapshot.ref.getDownloadURL());
                    }
                );
            }
        );
    }
}
